/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EmailTemplateType {
    INVITE_USER_INVESTOR = 'invite_user_investor',
    INVITE_USER_EXISTING_INVESTOR = 'invite_user_existing_investor',
    KYC_REJECTION = 'kyc_rejection',
    KYC_INFO_REQUEST = 'kyc_info_request',
    PASSWORD_RESET_REQUEST = 'password_reset_request',
    PASSWORD_RESET_CONFIRMATION = 'password_reset_confirmation',
    IP_ADDITIONAL_ALLOCATION = 'ip_additional_allocation',
    IP_LEAVER = 'ip_leaver',
    FUNDS_TRANSFER_REJECTION = 'funds_transfer_rejection',
    DOCUMENT_SIGNATURE_REQUEST = 'document_signature_request',
    CHANGE_EMAIL_REQUEST = 'change_email_request',
    CHANGE_EMAIL_NOTIFICATION = 'change_email_notification',
    BANK_ACCOUNT_REJECTION = 'bank_account_rejection',
    BANK_ACCOUNT_UPDATE_CONFIRMATION = 'bank_account_update_confirmation',
    SEND_SDW_DOCUMENTS = 'send_sdw_documents',
    SEND_DOWNLOAD_LINK = 'send_download_link',
    GENERATE_CONTRACT = 'generate_contract',
    INVITE_USER_SEND_DOCUMENT = 'invite_user_send_document',
    INVITE_ORGANIZATION_EXISTING_USER = 'invite_organization_existing_user',
    INVITE_ORGANIZATION_NEW_USER = 'invite_organization_new_user',
    REINVITE_USER = 'reinvite_user',
    INVITE_NEW_USER_TO_PROGRAMME = 'invite_new_user_to_programme',
    INVITE_EXISTING_USER_TO_PROGRAMME = 'invite_existing_user_to_programme',
    INVITE_NEW_USER_TO_DEAL = 'invite_new_user_to_deal',
    INVITE_EXISTING_USER_TO_DEAL = 'invite_existing_user_to_deal',
    INVITE_INVESTOR_SSO = 'invite_investor_SSO',
    INVITE_ADMIN_SSO = 'invite_admin_SSO',
    EMAIL_VERIFICATION = 'email_verification',
    WITNESS_SIGNING_INVITATION = 'witness_signing_invitation',
    REPRESENTATIVE_SIGNING_INVITATION = 'representative_signing_invitation',
    AUTHORISED_SIGNATORY_SIGNING_INVITATION = 'authorised_signatory_signing_invitation',
    KYC_CERTIFIER_INVITATION = 'kyc_certifier_invitation',
    SEND_KYC_REQUEST = 'send_kyc_request',
    FUNDS_TRANSFER_CONFIRMATION = 'funds_transfer_confirmation',
    DOCUMENT_SIGNATURE_REJECTION = 'document_signature_rejection',
    SEND_INVESTMENT_REMINDER = 'send_investment_reminder',
    SECOND_FACTOR_REMOVED = 'second_factor_removed',
}
